import { PiPlusCircleFill } from "react-icons/pi";
import { IoIosCheckmark } from "react-icons/io";
import { FiPlus } from "react-icons/fi";


const DeliveryStatusUpdater = ({
  status,
}) => {
  const orderStatuses = [
    { id: "Pending", name: "Order Received" },
    { id: "Processing", name: "Processing" },
    { id: "Ready to Ship", name: "Ready to Ship" },
    { id: "Shipped", name: "Shipped" },
    { id: "Delivered", name: "Delivered" },
    { id: "Cancelled", name: "Cancelled" },
  ];

  const getIndicator = (currentStatus) => {
    const index = orderStatuses.findIndex((s) => s.id === currentStatus);
    return index !== -1 ? index + 1 : 0;
  };

  const currentStep = getIndicator(status);

  return (
    <div className="flex flex-col">
      {status === "Cancelled" ? (
        <h2 className="text-red-500 font-medium text-base text-start mt-5 mb-5">
          This order has been cancelled
        </h2>
      ) : (
        <h2 className="text-slate-500 text-base text-start mt-5 mb-5">
          Click the button to update the delivery status
        </h2>
      )}
      <div className="flex items-baseline">
        {orderStatuses.map((item, index) => (
          <div
            key={item.id}
            className="flex flex-col justify-center items-center w-1/5"
          >
            {index < currentStep ? (
              <>
                <div className="bg-primary3 w-[24px] h-[24px] rounded-full flex justify-center items-center z-50">
                  <IoIosCheckmark className="text-white text-[24px]" />
                </div>
                <hr
                  className={`relative border-[3px] w-full -mt-4 border-primary3 ${
                    index === 0 ? "rounded-tl-lg rounded-bl-lg" : ""
                  } ${
                    index === orderStatuses.length - 1
                      ? "rounded-tr-lg rounded-br-lg"
                      : ""
                  }`}
                />
                <h2 className="text-base font-semibold text-primary3 mt-4 mx-1 overflow-hidden">
                  {item.name}
                </h2>
              </>
            ) : (
              <>
                <div className="w-[24px] h-[24px] bg-[#D2D5EE] rounded-full flex justify-center items-center">
                  <FiPlus className="text-white text-[24px]" />
                </div>
                <hr
                  className={`relative border-[3px] w-full -mt-4 -z-50 ${
                    index === 0 ? "rounded-tl-lg rounded-bl-lg" : ""
                  } ${
                    index === orderStatuses.length - 1
                      ? "rounded-tr-lg rounded-br-lg"
                      : ""
                  }`}
                />
                <h2 className="text-base font-semibold text-[#D2D5EE] mt-4 mx-1 overflow-hidden">
                  {item.name}
                </h2>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeliveryStatusUpdater;
